import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './config'; // Initializes global.config
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import './index.css';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import i18n from './i18n';
import { DataProvider } from './DataContext';
import { PageProvider } from './PageContext';
import { ToastProvider } from './ToastContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router basename="/">
    <React.StrictMode>
      <GoogleReCaptchaProvider reCaptchaKey={global.config.reCAPTCHAkey}>
        <I18nextProvider i18n={i18n}>
          <DataProvider>
            <PageProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </PageProvider>
          </DataProvider>
        </I18nextProvider>
      </GoogleReCaptchaProvider>
    </React.StrictMode>
  </Router>
);

reportWebVitals();